
/* 
  Collates all the snapshots names 
  < Output = snapshotNames (they contain .csv sufffix) >
*/

export async function getAllSnapshotsNames(S3) {
  // S3 bucket and prefix
  const bucket = process.env.REACT_APP_S3_BUCKET; 
  const prefix = localStorage.getItem("s3Link") + "/Forms" + "/Snapshots";

  try {
    const params = {
      Bucket: bucket,
      Prefix: prefix,
    };

    const data = await S3.listObjectsV2(params).promise();

    // Extract and return the snapshot names ( they contain .csv suffix )
    const snapshotNames = data.Contents.map((object) => object.Key.replace(prefix + "/", ""));
    return snapshotNames;
    
  } catch (error) {
    console.error(error);
    return [];
  }
}